import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Tab, TabProps, units } from '@hbf/dsl';

export const useStyles = makeStyles()(t => ({
  root: {
    zIndex: 1,
    maxWidth: 'initial',
    textTransform: 'none',
    minWidth: units.rem(9),
    [t.breakpoints.up('md')]: {
      minWidth: units.rem(15),
    },
  },
  selected: {
    color: t.palette.primary.main,
  },
}));

export const StyledTab = React.forwardRef<HTMLDivElement, TabProps>(
  ({ classes, ...otherProps }, ref) => {
    const { classes: ownClasses, cx } = useStyles();

    return (
      <Tab
        ref={ref}
        disableRipple
        {...otherProps}
        classes={{
          ...ownClasses,
          ...classes,
          root: cx(ownClasses.root, classes?.root),
          selected: cx(ownClasses.selected, classes?.selected),
        }}
      />
    );
  },
);
